import { render, staticRenderFns } from "./TypePrototypeCardListItem.vue?vue&type=template&id=2346b078&scoped=true&"
import script from "./TypePrototypeCardListItem.vue?vue&type=script&lang=js&"
export * from "./TypePrototypeCardListItem.vue?vue&type=script&lang=js&"
import style0 from "./TypePrototypeCardListItem.vue?vue&type=style&index=0&id=2346b078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2346b078",
  null
  
)

export default component.exports